<template>
  <v-select
    id="solution-select"
    v-model="filter.solucaoId"
    item-text="nome"
    item-name="solucaoId"
    item-value="solucaoId"
    :items="filter.solutions"
    label="Solução"
    placeholder="Solução"
    clearable
    @change="$emit('changeSolution')"
  >
    <template slot="no-data">
      Nenhuma Solução retornada
    </template>
  </v-select>
</template>

<script>
export default {
  name: "AppSolutionCombobox",
  props: ["filter"]
};
</script>
